// extracted by mini-css-extract-plugin
export default {"cardproduct":"cardproduct_cardproduct__hdXHk","cardProdImg":"cardproduct_cardProdImg__92Wbl","imgWrapper":"cardproduct_imgWrapper__ilT1W"};